import React, { useEffect, useState } from 'react';
import Button from '../Button';
import Form, { useForm } from '../Form';
import Field from '../Field';
import cardIcon from '../../assets/feeda-icon.svg';
import magicStick from '../../assets/magic-stick.svg';
import agentService from '../../services/agentService';
import { MenuBtn, StyledCreatAgentModal } from './CreatAgentModal.style';
import Toast from '../Toast';
import CenterModal from '../Modal/CenterModal';
import { FaWandMagicSparkles } from 'react-icons/fa6';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import toolsService from '../../services/toolsService';
import { BsPlusSquare } from 'react-icons/bs';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../Context/authContext';
import memoryService from '../../services/memoryService';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { FiEdit } from 'react-icons/fi';
import ModalContainer from '../ModalContainer';
import DeleteMemoryModal from './DeleteMemoryModal';
import UpdateMemoryModal from './UpdateMemoryModal';
import Loaders from '../Loaders';
import { formatDate } from '../../helpers/common';
import { ReponseMenu, StyleItem } from '../SideBar/SideBar.styles';
import triggerService from '../../services/triggerService';
import skillsService from '../../services/skillsService';

const agentTypes = [
  {
    label: 'GENERATIVE',
    value: 'generative',
  },
  {
    label: 'PERSONA',
    value: 'persona',
  },
  {
    label: 'ACTION',
    value: 'action',
  },
];

const CreatAgentModal = ({ onClose, setSuccessModal, isEdit, isDuplicate }) => {
  const [domainLoading, setDomainLoading] = useState(false);
  const [promptLoading, setPromptLoading] = useState(false);
  const [memoryEnabled, setMemoryEnabled] = useState(false);
  const [triggerEnabled, setTriggerEnabled] = useState(true);
  const [open, setOpen] = useState(false);
  const [domainModal, setDomainModal] = useState(false);
  const [models, setModels] = useState([]);
  const [domains, setDomains] = useState([]);
  const [allModels, setAllModels] = useState([]);
  const [modelsKeys, setModelsKeys] = useState([]);
  const [activeModelsKeys, setActiveModelsKeys] = useState('OpenAi');
  const [tools, setTools] = useState([]);
  const [skills, setSkills] = useState([]);
  const [selectedAgentIcon, setSelectedAgentIcon] = useState(null);
  const { user, fetch, refetch } = useContextHook(AuthContext, v => ({
    user: v.user,
    fetch: v.fetch,
    refetch: v.refetch,
  }));

  const { _data } = memoryService.GetMemoryList(isEdit?.id, fetch);

  const { trigger_data } = triggerService.GetTriggersList(isEdit?.id, fetch);

  const togglePrompt = () => {
    setOpen(prev => !prev);
  };

  const toggleDomainModal = () => {
    setDomainModal(prev => !prev);
  };

  const getAllAgentData = useQuery({
    queryKey: ['get-all-agents'],
    queryFn: () => agentService.getAllAgent(),
    staleTime: Infinity,
  });

  const getDomains = async () => {
    const resp = await agentService.getAllfeedaAgentsCategory();
    const restructuredDataForSelect = resp?.domains?.map(elem => ({ label: elem?.domain, value: elem?.domain_id }));
    setDomains([...restructuredDataForSelect]);
  };

  const getModels = async () => {
    const allModels = get_all_models?.data?.models?.flatMap(providerObj => {
      const providerName = Object.keys(providerObj)[0];
      const models = providerObj[providerName];
      return models.map(model => ({
        ...model,
        provider: providerName,
      }));
    });

    const convertedData2 = allModels?.map(elem => ({
      label: (
        <div className="flex-wrap">
          <img src={elem?.icon} alt="img" width={30} height={30} />
          <span className="text">{elem?.name}</span>
        </div>
      ),
      value: elem?.id,
    }));

    const convertedData = get_all_models?.data?.models?.map(providerObj => {
      const providerName = Object.keys(providerObj)[0];
      const models = providerObj[providerName];

      const formattedModels = models.map(model => ({
        label: (
          <div className="flex-wrap">
            <img src={model?.icon} alt="img" width={30} height={30} />
            <span className="text">{model?.name}</span>
            <span className="description">{model?.description}</span>
          </div>
        ),
        value: model?.id,
        description: model?.description,
      }));

      // Return in the same structure
      return {
        [providerName]: formattedModels,
      };
    });

    const providerKeys = get_all_models?.data?.models?.map(providerObj => {
      const providerName = Object.keys(providerObj)[0];
      return {
        label: providerName,
        value: providerName,
      };
    });

    setModels(convertedData);
    setModelsKeys(providerKeys);
    setAllModels(convertedData2);
  };

  const getSkills = async () => {
    try {
      const resp = await skillsService.getAllSkills();
      const convertedData = resp.skills.map(elem => ({
        label: (
          <>
            <div className="flex-wrap">
              <span className="text">{elem?.name}</span>
            </div>
          </>
        ),
        value: elem?.folder,
      }));

      setSkills(convertedData);
    } catch (error) {
      console.log(error);
    }
  };

  const getTools = async () => {
    try {
      const resp = await toolsService.getAllTools('user_created');
      const resp2 = await toolsService.getAllTools('admin_created');
      const convertedData = resp.tools.map(elem => ({
        label: (
          <>
            <div className="flex-wrap">
              <span className="text">{elem?.tool_name}</span>
            </div>
          </>
        ),
        value: elem?.tool_id,
      }));
      const convertedData2 = resp2.tools.map(elem => ({
        label: (
          <>
            <div className="flex-wrap tag-section">
              <span className="text">{elem?.tool_name}</span>
              <span className="tag-text">Admin Tools</span>
            </div>
          </>
        ),
        value: elem?.tool_id,
      }));
      setTools([...convertedData, ...convertedData2]);
    } catch (error) {
      console.log(error);
    }
  };

  const get_all_models = useQuery({
    queryKey: ['get-all-models'],
    queryFn: () => agentService.getAllModels(),
    staleTime: Infinity,
  });
  const get_single_agent = useQuery({
    queryKey: ['get-single-agent'],
    queryFn: () => agentService.getAgentDetail(isEdit?.id),
    enabled: !!isEdit?.id,
  });
  useEffect(() => {
    getModels();
    getTools();
    getSkills();
    getDomains();
  }, [get_single_agent.isSuccess, get_all_models.isSuccess, isEdit]);

  const details = get_single_agent?.data?.detail;

  const findProvider = modelId => {
    const providerObj = models.find(obj => {
      const key = Object.keys(obj)[0];
      return obj[key].some(model => model.value === modelId);
    });

    return providerObj ? Object.keys(providerObj)[0] : null;
  };

  useEffect(() => {
    if (isEdit && models?.length !== 0 && details && tools) {
      setTimeout(() => {
        form.setFieldsValue({
          agent_name: details?.agent_name,
          agent_type: agentTypes?.find(elem => elem?.value == details?.behavior_type),
          description: details?.description,
          model_provider: modelsKeys?.find(elem => elem?.value == findProvider(details?.model_id)),
          model_id: allModels?.find(elem => elem?.value == details?.model_id),
          domain_id: domains?.find(elem => elem?.value == details?.domain_id),
          instructions: details?.instructions,
          tool_id: tools?.filter(elem => details?.tools?.includes(elem?.value)),
          skills: skills?.filter(elem => details?.skills?.includes(elem?.value)),
        });
        if (!isDuplicate) {
          form.setFieldsValue({
            icon: details?.icon === null || !details?.icon ? cardIcon : details?.icon,
          });
          setSelectedAgentIcon(details?.icon === null || !details?.icon ? cardIcon : details?.icon);
        }
        setMemoryEnabled(details?.enable_user_memories ?? false);
        setActiveModelsKeys(modelsKeys?.find(elem => elem?.value == findProvider(details?.model_id)));
      }, 1000);
    }
  }, [models, get_single_agent.isSuccess, get_single_agent?.isFetching, details, tools, skills]);

  const handleSubmit = async e => {
    if (isEdit && !isDuplicate) {
      editAgent.mutate(e);
    } else {
      addAgent.mutate(e);
    }
  };

  const queryClient = useQueryClient();

  const editAgent = useMutation({
    mutationFn: async e => {
      const payload = new FormData();
      payload.append('agent_id', isEdit?.id);
      payload.append('behavior_type', e?.agent_type?.value);
      payload.append('agent_name', e?.agent_name);
      payload.append('model_id', e?.model_id?.value);
      payload.append('domain_id', e?.domain_id?.value);
      payload.append('description', e?.description);
      payload.append('instructions', e?.instructions);
      payload.append('enable_user_memories', memoryEnabled);
      if (e?.icon instanceof File) {
        payload.append('icon', e.icon);
      }
      payload.append('tools', e?.tool_id ? e?.tool_id?.map(data => data?.value).join(',') : []);
      e?.skills?.forEach(s => payload.append('skills', s?.value));

      return await agentService.EditAgent(payload);
    },
    onSuccess: response => {
      Toast({
        type: 'success',
        message: response.detail,
      });
      if (onClose) {
        onClose();
      }
      queryClient.invalidateQueries({ queryKey: ['get-all-agents'] });
    },
    onError: err => {
      Toast({
        type: 'error',
        message: err.detail,
      });
    },
  });

  const addAgent = useMutation({
    mutationFn: async e => {
      const payload = new FormData();
      payload.append('agent_name', e?.agent_name);
      payload.append('behavior_type', e?.agent_type?.value);
      payload.append('model_id', e?.model_id?.value);
      payload.append('domain_id', e?.domain_id?.value);
      payload.append('description', e?.description);
      payload.append('instructions', e?.instructions);
      payload.append('enable_user_memories', memoryEnabled);
      if (e?.icon instanceof File) {
        payload.append('icon', e?.icon);
      }
      payload.append('tools', e?.tool_id ? e?.tool_id?.map(data => data?.value).join(',') : []);
      e?.skills?.forEach(s => payload.append('skills', s?.value));

      return await agentService.createAgent(payload);
    },
    onSuccess: response => {
      if (onClose) {
        onClose();
      }
      setSuccessModal(true);
      queryClient.invalidateQueries({ queryKey: ['get-all-agents'] });
    },
    onError: err => {
      console.log(err);
      Toast({
        type: 'error',
        message: err.detail,
      });
    },
  });

  const [form, form2, form3] = useForm();

  const generatePromt = async ({ prompt }) => {
    try {
      setPromptLoading(true);
      const resp = await agentService.generatePrompt(prompt);
      if (resp.success) {
        const formatted = resp.prompt.replace(/\\n/g, '\n');
        form.setFieldsValue({
          instructions: formatted,
        });
        Toast({
          type: 'success',
          message: 'Prompt Generated Successfully',
        });
        setPromptLoading(false);
        setOpen(false);
      }
    } catch (error) {
      console.log(error);
      setPromptLoading(false);
    }
  };

  const generateDomain = async e => {
    const payload = {
      domain: e?.domainName,
      description: e?.domainDescription,
    };
    try {
      setDomainLoading(true);
      const resp = await agentService.generateDomain(payload);
      if (resp?.success) {
        Toast({
          type: 'success',
          message: 'Domain Created Successfully',
        });
        setDomainLoading(false);
        setDomainModal(false);
        getDomains();
      } else {
      }
    } catch (error) {
      console.log(error);
      Toast({
        type: 'error',
        message: error?.detail || 'Something went wrong!!!',
      });
      setDomainLoading(false);
    }
  };

  return (
    <>
      {isEdit && get_single_agent?.isFetching ? (
        <Loaders pageLoader />
      ) : (
        <>
          <StyledCreatAgentModal>
            <CenterModal open={open} setOpen={setOpen} width={'600'} title={'Generate agent instructions'}>
              <Form form={form2} className="prompt-holder" onSubmit={generatePromt}>
                <Form.Item label="" type="textarea" name="prompt" rounded placeholder="Enter your prompt here.">
                  <Field />
                </Form.Item>
                <Button width="200px" loader={promptLoading}>
                  Generate prompt
                </Button>
              </Form>
            </CenterModal>
            <CenterModal open={domainModal} setOpen={setDomainModal} width={'600'} title={'Create Custom Domain'}>
              <Form form={form3} className="prompt-holder" onSubmit={generateDomain}>
                <Form.Item
                  label="Domain Name"
                  type="text"
                  name="domainName"
                  rounded
                  placeholder="Enter your domain name"
                  rules={[{ required: true, message: 'Domain name is required' }]}>
                  <Field />
                </Form.Item>
                <Form.Item
                  label="Description"
                  type="textarea"
                  name="domainDescription"
                  rounded
                  placeholder="Enter your description here."
                  rules={[{ required: true, message: 'Domain description is required' }]}>
                  <Field />
                </Form.Item>
                <Button width="200px" loader={domainLoading}>
                  Create Domain
                </Button>
              </Form>
            </CenterModal>
            <Form form={form} onSubmit={handleSubmit}>
              <div className="column-wrap">
                <div className="column">
                  <Form.Item
                    label="Agent Name"
                    type="text"
                    rounded
                    name="agent_name"
                    placeholder="Name your agent"
                    rules={[
                      {
                        required: true,
                        message: 'agent name is required',
                      },
                    ]}>
                    <Field />
                  </Form.Item>

                  <Form.Item
                    options={agentTypes}
                    label="Agent Type"
                    type="select"
                    rounded
                    disabled={isEdit}
                    name="agent_type"
                    placeholder="Select your agent type"
                    rules={[
                      {
                        required: true,
                        message: 'agent type is required',
                      },
                    ]}>
                    <Field />
                  </Form.Item>

                  <Form.Item
                    label="Icon"
                    type="img"
                    rounded
                    name="icon"
                    uploadTitle="Upload Icon"
                    disc="File size must be less than 5mb in JPG, PNG or SVG format."
                    img={selectedAgentIcon}
                    rules={[
                      {
                        required: true,
                        message: 'Icon is required',
                      },
                    ]}>
                    <Field />
                  </Form.Item>
                  <Form.Item
                    options={tools}
                    label="Tools"
                    type="select"
                    rounded
                    name="tool_id"
                    placeholder="Select Tool"
                    isMulti>
                    <Field />
                  </Form.Item>
                  <Form.Item
                    options={skills}
                    label="Skills"
                    type="select"
                    rounded
                    name="skills"
                    placeholder="Select Skill"
                    isMulti>
                    <Field />
                  </Form.Item>
                  <Form.Item
                    options={domains}
                    label={
                      <>
                        Domain
                        <span className="btn-domain" onClick={toggleDomainModal}>
                          Create Domain <BsPlusSquare />
                        </span>
                      </>
                    }
                    type="select"
                    rounded
                    name="domain_id"
                    placeholder="Select any domain">
                    <Field />
                  </Form.Item>
                  <Form.Item
                    options={modelsKeys}
                    label="Provider"
                    type="select"
                    rounded
                    name="model_provider"
                    placeholder="Select any provider to proceed"
                    value={activeModelsKeys}
                    onChange={e => {
                      setActiveModelsKeys(e.target?.value);
                    }}>
                    <Field />
                  </Form.Item>
                  <Form.Item
                    options={
                      models?.find(obj => Object.keys(obj)[0] === activeModelsKeys?.value)?.[activeModelsKeys?.value]
                    }
                    label="Response Model"
                    type="select"
                    rounded
                    name="model_id"
                    placeholder="Select any model to proceed"
                    rules={[
                      {
                        required: true,
                        message: 'response model is required',
                      },
                    ]}>
                    <Field />
                  </Form.Item>
                </div>
                <div className="column">
                  <Form.Item
                    customHeight
                    noMargin
                    label={
                      <>
                        Instructions
                        <span className="btn-prompt" onClick={togglePrompt}>
                          <FaWandMagicSparkles />
                        </span>
                      </>
                    }
                    type="textarea"
                    rounded
                    name="instructions"
                    placeholder="Enter your prompt here. Be creative, be bold, or just be straightforward. We’ll handle it either way!"
                    rules={[
                      {
                        required: true,
                        message: 'Instructions is required',
                      },
                    ]}>
                    <Field />
                  </Form.Item>
                </div>
              </div>

              <Form.Item
                label="Description"
                type="textarea"
                rounded
                name="description"
                placeholder="This project is a collection of threads related to planning..."
                rules={[
                  {
                    required: true,
                    message: 'description is required',
                  },
                ]}>
                <Field />
              </Form.Item>

              <div className="memory-wrap">
                <div className="head">
                  <h2 className="memory-title">Memory Settings</h2>
                  <div
                    className={`btn-check ${memoryEnabled ? 'checked' : ''}`}
                    onClick={() => setMemoryEnabled(!memoryEnabled)}
                  />
                </div>

                {memoryEnabled ? (
                  <>
                    <div className="memory-enable">
                      <div className="stick-wrap">
                        <img src={magicStick} alt="magic-stick" />
                      </div>
                      <div>
                        <strong className="enable-title">Memory Enabled</strong>
                        <p className="enable-desc">
                          Your agent will remember context from previous interactions and learn from user preferences
                        </p>
                      </div>
                    </div>
                    {_data?.results?.results?.map((data, index) => (
                      <div className="memory" key={index}>
                        <div>
                          <strong className="memory-heading">{data?.memory}</strong>
                          <strong className="memory-date">{formatDate(data?.created_at)}</strong>
                        </div>
                        <div className="icon-wrap">
                          {data?.categories && (
                            <div className="category-wrap">
                              <div className="category">{data?.categories[0]}</div>
                              {data?.categories?.length > 1 && (
                                <ReponseMenu
                                  menuButton={
                                    <MenuBtn>
                                      <div className="category">+ {data?.categories?.length - 1} more</div>
                                    </MenuBtn>
                                  }>
                                  {data?.categories?.slice(1)?.map((item, index) => (
                                    <StyleItem key={index}>
                                      <div className="text">{item}</div>
                                    </StyleItem>
                                  ))}
                                </ReponseMenu>
                              )}
                            </div>
                          )}
                          <ModalContainer
                            width="600"
                            title="Edit Memory"
                            content={({ onClose }) => (
                              <UpdateMemoryModal onClose={onClose} data={data} refetch={refetch} />
                            )}
                            btnComponent={({ onClick }) => <FiEdit size={18} color="#313131" onClick={onClick} />}
                          />

                          <ModalContainer
                            width="600"
                            title="Delete Memory"
                            content={({ onClose }) => (
                              <DeleteMemoryModal onClose={onClose} data={data} refetch={refetch} />
                            )}
                            btnComponent={({ onClick }) => (
                              <RiDeleteBin6Line size={18} color="#ef4444" onClick={onClick} />
                            )}
                          />
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <div className="memory-disable">
                    <div className="stick-wrap">
                      <img src={magicStick} alt="magic-stick" />
                    </div>
                    <strong className="disable-title">Memory Disabled</strong>
                    <p className="disable-desc">
                      Enable memories to allow your agent to remember user preferences and context across conversations
                    </p>
                  </div>
                )}
              </div>

              <div className="memory-wrap">
                <div className="head">
                  <h2 className="memory-title">Triggers Settings</h2>
                  <div
                    className={`btn-check ${triggerEnabled ? 'checked' : ''}`}
                    onClick={() => setTriggerEnabled(!triggerEnabled)}
                  />
                </div>

                {triggerEnabled ? (
                  <>
                    <div className="memory-enable">
                      <div className="stick-wrap">
                        <img src={magicStick} alt="magic-stick" />
                      </div>
                      <div>
                        <strong className="enable-title">Triggers Enabled</strong>
                        <p className="enable-desc">
                          Your agent will remember context from previous interactions and learn from user preferences
                        </p>
                      </div>
                    </div>

                    {trigger_data?.triggers?.map((data, index) => (
                      <div className="memory" key={index}>
                        <div>
                          <strong className="memory-heading capitalize">{data?.query}</strong>
                          {/* <strong className="memory-date">{formatDate(data?.created_at)}</strong> */}
                        </div>
                        <div className="icon-wrap">
                          <div className="category-wrap">
                            <div className="category capitalize">{data?.status}</div>
                          </div>

                          {/* <ModalContainer
                            width="600"
                            title="Edit Memory"
                            content={({ onClose }) => (
                              <UpdateMemoryModal onClose={onClose} data={data} refetch={refetch} />
                            )}
                            btnComponent={({ onClick }) => <FiEdit size={18} color="#313131" onClick={onClick} />}
                          />

                          <ModalContainer
                            width="600"
                            title="Delete Memory"
                            content={({ onClose }) => (
                              <DeleteMemoryModal onClose={onClose} data={data} refetch={refetch} />
                            )}
                            btnComponent={({ onClick }) => (
                              <RiDeleteBin6Line size={18} color="#ef4444" onClick={onClick} />
                            )}
                          /> */}
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <div className="memory-disable">
                    <div className="stick-wrap">
                      <img src={magicStick} alt="magic-stick" />
                    </div>
                    <strong className="disable-title">Triggers Disabled</strong>
                    <p className="disable-desc">
                      Enable triggers to allow your agent to remember user preferences and context across conversations
                    </p>
                  </div>
                )}
              </div>

              <div className="btn-holder">
                {onClose && (
                  <Button width="150px" variant="secondary-outline" onClick={() => onClose()}>
                    Cancel
                  </Button>
                )}
                <Button
                  width={onClose ? '150px' : '200px'}
                  loader={editAgent?.isPending || addAgent?.isPending}
                  variant={
                    getAllAgentData?.data?.agents?.length >= user?.plan?.agent_creation_limit &&
                    !isEdit &&
                    'secondary-outline'
                  }
                  disabled={getAllAgentData?.data?.agents?.length >= user?.plan?.agent_creation_limit && !isEdit}>
                  {getAllAgentData?.data?.agents?.length >= user?.plan?.agent_creation_limit && !isEdit
                    ? 'Agent limit exceed'
                    : isEdit && !isDuplicate
                      ? 'Update Agent'
                      : 'Create Agent'}
                </Button>
              </div>
            </Form>
          </StyledCreatAgentModal>
        </>
      )}
    </>
  );
};

export default CreatAgentModal;
